export default class FotobookEditor {
  constructor() {
    console.log('FotobookEditor: Constructor called');
    this.currentPage = 1;
    this.selectedPage = 1; // Página seleccionada para aplicar formato
    this.selectedFormats = {};
    this.selectedPhotos = [];
    this.placedPhotos = {}; // { [pageNumber]: { [slotIndex]: { url: string, fileIndex: number } } }
    this.config = window.FOTOBOOK_CONFIG || {};
    
    // Configuración específica para covers
    this.currentCoverSheet = 1;
    // selectedCoverSheet eliminado - las portadas no son seleccionables, solo editables
    this.selectedCoverFormat = null;
    this.coverConfig = window.COVER_CONFIG || {};
    
    console.log('FotobookEditor: Config loaded:', this.config);
    console.log('FotobookEditor: Cover config loaded:', this.coverConfig);

    // Ejecutar prueba de cálculo de posiciones
    this.testPositionCalculation();

    // Probar formato de múltiples fotos
    this.testMultiplePhotosFormat();

    // Analizar layouts de múltiples fotos
    this.analyzeMultiplePhotosLayout();

    // Mostrar resumen de asignación cíclica
    this.showCyclicAssignmentSummary();

    // Analizar opciones de configuración
    this.analyzeConfigurationOptions();

    // Mostrar recomendaciones
    this.showConfigurationRecommendations();

    // Inicializar automáticamente si estamos en una página de fotobooks
    if (document.getElementById('fotobook-selection-section')) {
      console.log('FotobookEditor: Found fotobook section, initializing...');
      this.init();
    } else {
      console.log('FotobookEditor: No fotobook section found');
    }
  }

  init() {
    console.log('FotobookEditor: Initializing...');
    this.initializeEventListeners();
    this.renderSheetPreviews();
    this.initializeDefaultFormats();
    
    // Inicializar covers si hay configuración disponible
    if (this.coverConfig && this.coverConfig.covers && this.coverConfig.covers.length > 0) {
      this.initializeDefaultCover();
    }

    // Actualizar dimensiones de página según el paquete seleccionado
    this.updatePageDimensions();

    // Verificar que las dimensiones se aplicaron correctamente
    this.verifyDimensions();

    // Verificar que los templates se están escalando correctamente
    this.verifyTemplateScaling();

    // Verificar que el escalado proporcional funcione correctamente
    this.verifyProportionalScaling();

    // Inicializar indicadores de las páginas del libro
    this.updateBookPageIndicators();

    // Inicializar tooltips de las páginas
    this.updatePageTooltips();

    console.log('FotobookEditor: Initialization complete');
    
    // Diagnóstico de páginas disponibles
    this.diagnosePageSelection();
  }

  initializeEventListeners() {
    console.log('FotobookEditor: Initializing event listeners');

    // Navegación de hojas (sheets)
    const prevSheetButton = document.getElementById('prev-sheet');
    const nextSheetButton = document.getElementById('next-sheet');

    if (prevSheetButton) {
      console.log('FotobookEditor: Found prev-sheet button');
      prevSheetButton.addEventListener('click', () => {
        console.log('FotobookEditor: Prev sheet button clicked');
        this.navigateSheet(-1);
      });
    } else {
      console.log('FotobookEditor: prev-sheet button not found');
    }

    if (nextSheetButton) {
      console.log('FotobookEditor: Found next-sheet button');
      nextSheetButton.addEventListener('click', () => {
        console.log('FotobookEditor: Next sheet button clicked');
        this.navigateSheet(1);
      });
    } else {
      console.log('FotobookEditor: next-sheet button not found');
    }

    // Selector de color de fondo de portada - usar delegación de eventos
    // ya que los botones se crean dinámicamente por CoverSelector
    const paletteContainer = document.getElementById('cover-background-palette');
    if (paletteContainer) {
      paletteContainer.addEventListener('click', (e) => {
        const button = e.target.closest('.palette-color-btn-fotobook, [data-color]');
        if (!button) return;
        
        e.preventDefault();
        const color = button.getAttribute('data-color');
        if (!color) return;
        
        // Remover clase active de todos los botones
        paletteContainer.querySelectorAll('.palette-color-btn-fotobook, [data-color]').forEach(btn => {
          btn.classList.remove('active');
        });
        
        // Agregar clase active al botón clickeado
        button.classList.add('active');
        
        // Actualizar el input hidden
        const hiddenInput = document.getElementById('cover-background-color');
        if (hiddenInput) {
          hiddenInput.value = color;
        }
        
        // Actualizar el rect de la portada izquierda
        const coverLeftRect = document.getElementById('cover-left-sheet-background-rect');
        if (coverLeftRect) {
          coverLeftRect.setAttribute('fill', color);
        }
        
        // Actualizar el rect de la portada derecha también
        const coverRightRect = document.getElementById('cover-right-sheet-background-rect');
        if (coverRightRect) {
          coverRightRect.setAttribute('fill', color);
        }
      });
    }

    // Event listeners para las hojas del libro (sheets) y drop en slots
    const leftSheet = document.getElementById('left-sheet-preview');
    const rightSheet = document.getElementById('right-sheet-preview');
    
    console.log(`FotobookEditor: Setting up event listeners for sheets`);
    console.log(`FotobookEditor: Left sheet found: ${leftSheet ? 'YES' : 'NO'}`);
    console.log(`FotobookEditor: Right sheet found: ${rightSheet ? 'YES' : 'NO'}`);

    // Configurar event listener para hoja izquierda
    if (leftSheet) {
      console.log(`FotobookEditor: Setting up event listener for left sheet: ${leftSheet.id}`);
      leftSheet.addEventListener('click', () => {
        console.log(`FotobookEditor: Left sheet clicked (element ID: ${leftSheet.id})`);
        this.selectBookSheet(1);
      });
    }

    // Configurar event listener para hoja derecha
    if (rightSheet) {
      console.log(`FotobookEditor: Setting up event listener for right sheet: ${rightSheet.id}`);
      rightSheet.addEventListener('click', () => {
        console.log(`FotobookEditor: Right sheet clicked (element ID: ${rightSheet.id})`);
        this.selectBookSheet(2);
      });
    }

    // Las portadas (covers) no son seleccionables, solo editables
    // No se configuran event listeners para selección de portadas

    // Mantener compatibilidad con elementos .sheet-content y .cover-sheet-container para drop de fotos
    const bookSheets = document.querySelectorAll('.sheet-content, .cover-sheet-container');
    console.log(`FotobookEditor: Found ${bookSheets.length} sheet elements for drag/drop`);

    bookSheets.forEach((sheet, index) => {
      // Delegación para manejar dragover/drop sobre el SVG/slots
      sheet.addEventListener('dragover', (ev) => {
        if (ev.dataTransfer && ev.dataTransfer.types.includes('text/fotobook-file-index')) {
          ev.preventDefault();
          ev.dataTransfer.dropEffect = 'copy';
        }
      });

      sheet.addEventListener('drop', (ev) => {
        const fileIndex = ev.dataTransfer?.getData('text/fotobook-file-index');
        if (fileIndex === undefined || fileIndex === null || fileIndex === '') return;
        ev.preventDefault();

        // Encontrar slot más cercano si se suelta sobre rect/g de slot
        const target = ev.target;
        const slotEl = target.closest ? target.closest('.photo-slot, .photo-slot-rect') : null;
        if (!slotEl) return;

        const slotIndex = slotEl.getAttribute('data-slot-index');
        if (slotIndex === null) return;

        this.handlePhotoDropOnSlot(sheet, parseInt(slotIndex, 10), parseInt(fileIndex, 10));
      });
    });

    // Selección de formatos de sheets - ahora aplica directamente a la hoja activa
    const sheetFormatOptions = document.querySelectorAll('.sheet-format-option');
    console.log(`FotobookEditor: Found ${sheetFormatOptions.length} sheet format options`);

    sheetFormatOptions.forEach(option => {
      option.addEventListener('click', () => {
        console.log('FotobookEditor: Sheet format option clicked');
        this.selectSheetFormat(option);
      });
    });

    // Selección de formatos de covers - aplica a la portada activa
    const coverFormatOptions = document.querySelectorAll('.cover-format-option');
    console.log(`FotobookEditor: Found ${coverFormatOptions.length} cover format options`);

    coverFormatOptions.forEach(option => {
      option.addEventListener('click', () => {
        console.log('FotobookEditor: Cover format option clicked');
        this.selectCoverFormat(option);
      });
    });

  }

  handlePhotoDropOnSlot(pageEl, slotIndex, fileIndex) {
    // Obtener el archivo desde el selector global si existe
    if (!window.fotobookPhotoSelector) {
      console.warn('FotobookEditor: fotobookPhotoSelector no encontrado');
      return;
    }

    const file = window.fotobookPhotoSelector.getSelectedFiles()[fileIndex];
    if (!file) return;

    const svg = pageEl.querySelector('svg');
    if (!svg) return;

    // Buscar el rect del slot por data-slot-index
    const slotRect = svg.querySelector(`.photo-slot-rect[data-slot-index="${slotIndex}"]`);
    if (!slotRect) return;

    const x = parseFloat(slotRect.getAttribute('x'));
    const y = parseFloat(slotRect.getAttribute('y'));
    const w = parseFloat(slotRect.getAttribute('width'));
    const h = parseFloat(slotRect.getAttribute('height'));

    // Crear/actualizar grupo de slot para contener la imagen
    const slotGroup = svg.querySelector(`g.photo-slot[data-slot-index="${slotIndex}"]`);
    if (!slotGroup) return;

    // Remover imagen previa dentro del slot si existe
    const prevImg = slotGroup.querySelector('image');
    if (prevImg) prevImg.remove();

    // Crear URL del archivo (blob)
    const objectUrl = URL.createObjectURL(file);

    // Crear elemento <image> SVG y hacerlo cubrir el slot (object-fit: cover)
    const imgEl = document.createElementNS('http://www.w3.org/2000/svg', 'image');
    imgEl.setAttributeNS('http://www.w3.org/1999/xlink', 'href', objectUrl);
    imgEl.setAttribute('x', String(x));
    imgEl.setAttribute('y', String(y));
    imgEl.setAttribute('width', String(w));
    imgEl.setAttribute('height', String(h));
    imgEl.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    imgEl.setAttribute('data-file-index', String(fileIndex));

    // Insertar la imagen después del rect para que cubra el área
    slotGroup.appendChild(imgEl);

    // Determinar número de hoja real desde el elemento
    const isLeftSheet = pageEl.id === 'left-sheet-preview';
    const pageNumber = isLeftSheet ? this.currentPage : this.currentPage + 1;
    if (!this.placedPhotos[pageNumber]) this.placedPhotos[pageNumber] = {};
    this.placedPhotos[pageNumber][slotIndex] = { url: objectUrl, fileIndex };
  }

  selectBookSheet(pageNumber) {
    console.log(`FotobookEditor: Selecting book sheet ${pageNumber}`);
    console.log(`FotobookEditor: Current sheet: ${this.currentPage}`);
    console.log(`FotobookEditor: Total sheets: ${this.config.totalSheets}`);
    console.log(`FotobookEditor: Config object:`, this.config);

    // Determinar qué hoja del libro se seleccionó (izquierda = 1, derecha = 2)
    const isLeftSheet = pageNumber === 1;
    const isRightSheet = pageNumber === 2;

    console.log(`FotobookEditor: Is left sheet: ${isLeftSheet}, Is right sheet: ${isRightSheet}`);

    // Calcular la hoja real en el fotobook
    let actualPage;
    if (isLeftSheet) {
      actualPage = this.currentPage;
    } else if (isRightSheet) {
      actualPage = this.currentPage + 1;
    }

    console.log(`FotobookEditor: Calculated actual page: ${actualPage}`);

    // Verificar que la página existe
    if (actualPage > this.config.totalSheets) {
      console.log(`FotobookEditor: Page ${actualPage} does not exist (total sheets: ${this.config.totalSheets})`);
      console.log(`FotobookEditor: Cannot select non-existent page`);
      return;
    }

    // Verificar si la página seleccionada está en formato de doble página
    const leftPageFormat = this.selectedFormats[this.currentPage];
    const rightPageFormat = this.selectedFormats[this.currentPage + 1];
    const isInDoublePageFormat = leftPageFormat && rightPageFormat &&
      leftPageFormat.id === rightPageFormat.id &&
      leftPageFormat.double === true;

    // Si se está seleccionando una página que está en formato de doble página,
    // mostrar una advertencia o información
    if (isInDoublePageFormat) {
      console.log(`FotobookEditor: Selected page ${actualPage} is currently in double page format`);
      // Opcional: mostrar un tooltip o indicador de que cambiar el formato romperá el doble página
    }

    this.selectedPage = actualPage;
    console.log(`FotobookEditor: Set selectedPage to ${this.selectedPage}`);

    // Actualizar indicadores visuales de las páginas del libro
    this.updateBookPageIndicators();

    console.log(`FotobookEditor: Book page ${pageNumber} selected, actual page: ${actualPage}`);
    console.log(`FotobookEditor: Final selectedPage value: ${this.selectedPage}`);
  }

  // selectCoverSheet y updateCoverSheetIndicators eliminados
  // Las portadas no son seleccionables, solo editables

  updateBookPageIndicators() {
    // Obtener las hojas del libro
    const leftSheet = document.getElementById('left-sheet-preview');
    const rightSheet = document.getElementById('right-sheet-preview');

    if (!leftSheet || !rightSheet) {
      console.log('FotobookEditor: Book sheets not found');
      return;
    }

    // Obtener el contenedor de doble hoja (ahora es el contenedor padre)
    const bookPreviewContainer = document.querySelector('#sheets-container');

    // Remover indicadores de selección de todas las hojas
    leftSheet.classList.remove('selected', 'double-sheet');
    rightSheet.classList.remove('selected', 'double-sheet');

    // Ocultar todos los indicadores de selección
    const leftIndicator = leftSheet.querySelector('.sheet-selection-indicator');
    const rightIndicator = rightSheet.querySelector('.sheet-selection-indicator');
    const leftDoubleIndicator = leftSheet.querySelector('.double-sheet-indicator');
    const rightDoubleIndicator = rightSheet.querySelector('.double-sheet-indicator');

    if (leftIndicator) leftIndicator.style.opacity = '0';
    if (rightIndicator) rightIndicator.style.opacity = '0';
    if (leftDoubleIndicator) leftDoubleIndicator.style.opacity = '0';
    if (rightDoubleIndicator) rightDoubleIndicator.style.opacity = '0';

    // Determinar qué hoja del libro corresponde a la hoja seleccionada
    const isLeftSheetSelected = this.selectedPage === this.currentPage;
    const isRightSheetSelected = this.selectedPage === this.currentPage + 1;

    // Verificar si hay un formato de doble hoja aplicado
    const leftSheetFormat = this.selectedFormats[this.currentPage];
    const rightSheetFormat = this.selectedFormats[this.currentPage + 1];
    const isDoubleSheetFormat = leftSheetFormat && rightSheetFormat &&
      leftSheetFormat.id === rightSheetFormat.id &&
      leftSheetFormat.double === true;

    // Aplicar modo de libro abierto al contenedor (siempre activo)
    if (bookPreviewContainer) {
      // Siempre mantener las hojas juntas para simular libro abierto
      bookPreviewContainer.classList.add('double-sheet-mode');
      console.log('FotobookEditor: Applied book-open-mode to container (always active)');
    }

    // Aplicar indicador visual
    if (isDoubleSheetFormat) {
      // Si es formato de doble hoja, seleccionar ambas hojas
      leftSheet.classList.add('selected', 'double-sheet');
      rightSheet.classList.add('selected', 'double-sheet');
      if (leftDoubleIndicator) leftDoubleIndicator.style.opacity = '1';
      if (rightDoubleIndicator) rightDoubleIndicator.style.opacity = '1';
      console.log('FotobookEditor: Both sheets selected (double sheet format)');
    } else if (isLeftSheetSelected) {
      leftSheet.classList.add('selected');
      if (leftIndicator) leftIndicator.style.opacity = '1';
      console.log('FotobookEditor: Left sheet selected');
    } else if (isRightSheetSelected) {
      rightSheet.classList.add('selected');
      if (rightIndicator) rightIndicator.style.opacity = '1';
      console.log('FotobookEditor: Right sheet selected');
    }

    // Actualizar indicador de página seleccionada
    this.updatePageSelectionIndicator();
  }

  renderSheetPreviews() {
    document.querySelectorAll('.sheet-preview').forEach(container => {
      const config = container.dataset.config;
      if (config) {
        try {
          const layoutData = this.parseLayoutData(config);
          if (layoutData) {
            // Para previews pequeños, mantener 64x64 pero escalar proporcionalmente
            const realDimensions = this.getRealPageDimensions();
            const scaleFactor = Math.min(64 / realDimensions.width, 64 / realDimensions.height);
            const scaledWidth = realDimensions.width * scaleFactor;
            const scaledHeight = realDimensions.height * scaleFactor;
            const optionElement = container.closest('.sheet-format-option');
            const textConfig = optionElement ? this.buildCoverTextConfigFromDataset(optionElement.dataset) : null;
            const previewOptions = textConfig ? { textConfig } : undefined;
            
            container.innerHTML = this.generateSVGPreview(layoutData, scaledWidth, scaledHeight, previewOptions);
          } else {
            container.innerHTML = this.generateDefaultSVG(64, 64);
          }
        } catch (e) {
          console.error('Error rendering sheet preview:', e);
          container.innerHTML = this.generateDefaultSVG(64, 64);
        }
      }
    });
  }

  initializeDefaultFormats() {
    console.log('FotobookEditor: Initializing default formats');

    // Esperar un momento para asegurar que todos los elementos estén renderizados
    setTimeout(() => {
      // Obtener todos los formatos disponibles
      const formatOptions = document.querySelectorAll('.sheet-format-option');

      if (formatOptions.length > 0) {
        console.log(`FotobookEditor: Found ${formatOptions.length} format options, assigning cyclically to ${this.config.totalSheets} pages`);

        // Convertir NodeList a Array para facilitar el acceso
        const formatsArray = Array.from(formatOptions);

        // Asignar formatos cíclicamente a todas las páginas (no solo impares)
        for (let page = 1; page <= this.config.totalSheets; page++) {
          // Calcular el índice del formato usando módulo para rotación cíclica
          const formatIndex = (page - 1) % formatsArray.length;
          const selectedFormat = formatsArray[formatIndex];

          const formatInfo = {
            id: selectedFormat.dataset.sheetId,
            noPhotos: parseInt(selectedFormat.dataset.noPhotos, 10) || 0,
            fullPage: selectedFormat.dataset.fullPage === 'true',
            double: selectedFormat.dataset.double === 'true',
            config: selectedFormat.dataset.config,
            isCover: selectedFormat.dataset.isCover === 'true',
            textConfig: this.buildCoverTextConfigFromDataset(selectedFormat.dataset)
          };

          this.selectedFormats[page] = formatInfo;
          console.log(`FotobookEditor: Assigned format ${formatIndex + 1} to page ${page}:`, formatInfo);
        }

        // Debug: mostrar todos los formatos asignados
        console.log('FotobookEditor: All assigned formats:', this.selectedFormats);

        // Seleccionar visualmente el primer formato
        const firstFormat = formatsArray[0];
        firstFormat.classList.remove('border-gray-300');
        firstFormat.classList.add('border-petrol-500', 'bg-petrol-50', 'ring-2', 'ring-petrol-500');

        // console.log información del formato seleccionado
        console.log(`${formatsArray[0].dataset.noPhotos} foto(s) - Página 1`);

        // Actualizar la vista previa de la página actual
        this.updateDoublePagePreview(this.selectedFormats[this.currentPage]);



        // Mostrar mensaje de confirmación
        this.showCyclicAssignmentMessage();

        console.log('FotobookEditor: Cyclic format assignment complete');

      } else {
        console.log('FotobookEditor: No format options found');
      }
    }, 100);
  }

  initializeDefaultCover() {
    console.log('FotobookEditor: Initializing default cover');
    
    // Esperar un momento para asegurar que todos los elementos estén renderizados
    setTimeout(() => {
      // Obtener todos los formatos de covers disponibles
      const coverFormatOptions = document.querySelectorAll('.cover-format-option');

      if (coverFormatOptions.length > 0) {
        console.log(`FotobookEditor: Found ${coverFormatOptions.length} cover format options`);
        
        // Seleccionar el primer cover disponible o el cover por defecto
        let defaultCoverOption = null;
        if (this.coverConfig && this.coverConfig.defaultCoverId) {
          defaultCoverOption = Array.from(coverFormatOptions).find(
            opt => opt.dataset.coverId === String(this.coverConfig.defaultCoverId)
          );
        }
        
        // Si no se encuentra el cover por defecto, usar el primero
        if (!defaultCoverOption) {
          defaultCoverOption = coverFormatOptions[0];
        }
        
        // Seleccionar el cover por defecto
        if (defaultCoverOption) {
          this.selectCoverFormat(defaultCoverOption);
          console.log('FotobookEditor: Default cover initialized:', defaultCoverOption.dataset.coverId);
        }
      } else {
        console.log('FotobookEditor: No cover format options found');
      }
    }, 150);
  }

  showCyclicAssignmentSummary() {
    console.log('\n📋 RESUMEN DE ASIGNACIÓN CÍCLICA DE FORMATOS:');
    console.log('==============================================');

    const formatOptions = document.querySelectorAll('.sheet-format-option');
    const formatsArray = Array.from(formatOptions);

    if (formatsArray.length === 0) {
      console.log('❌ No hay formatos disponibles');
      return;
    }

    console.log(`📊 Total de formatos disponibles: ${formatsArray.length}`);
    console.log(`📄 Total de páginas: ${this.config.totalSheets}`);
    console.log(`🔄 Ciclos completos: ${Math.floor(this.config.totalSheets / formatsArray.length)}`);
    console.log(`📝 Páginas restantes: ${this.config.totalSheets % formatsArray.length}`);

    console.log('\n📋 FORMATOS DISPONIBLES:');
    formatsArray.forEach((format, index) => {
      console.log(`   ${index + 1}. ${format.dataset.noPhotos} foto(s) - ID: ${format.dataset.sheetId}`);
    });

    console.log('\n📄 ASIGNACIÓN POR PÁGINA:');
    for (let page = 1; page <= this.config.totalSheets; page++) {
      const formatIndex = (page - 1) % formatsArray.length;
      const format = formatsArray[formatIndex];
      const selectedFormat = this.selectedFormats[page];

      console.log(`   Página ${page}: Formato ${formatIndex + 1} (${format.dataset.noPhotos} foto(s))`);
      if (selectedFormat) {
        console.log(`     ✅ Asignado: ${selectedFormat.noPhotos} foto(s) - ID: ${selectedFormat.id}`);
      } else {
        console.log(`     ❌ No asignado`);
      }
    }

    console.log('\n🎯 PATRÓN DE REPETICIÓN:');
    const pattern = [];
    for (let i = 0; i < Math.min(formatsArray.length, this.config.totalSheets); i++) {
      const formatIndex = i % formatsArray.length;
      pattern.push(formatIndex + 1);
    }
    console.log(`   Patrón: ${pattern.join(' → ')}${this.config.totalSheets > formatsArray.length ? ' → ...' : ''}`);

    console.log('\n📊 ESTADÍSTICAS:');
    const formatCounts = {};
    for (let page = 1; page <= this.config.totalSheets; page++) {
      const formatIndex = (page - 1) % formatsArray.length;
      const formatName = `Formato ${formatIndex + 1}`;
      formatCounts[formatName] = (formatCounts[formatName] || 0) + 1;
    }

    Object.entries(formatCounts).forEach(([formatName, count]) => {
      console.log(`   ${formatName}: ${count} página(s)`);
    });

    console.log('==============================================\n');
  }

  showCyclicAssignmentMessage() {
    const formatOptions = document.querySelectorAll('.sheet-format-option');
    const formatsArray = Array.from(formatOptions);

    if (formatsArray.length === 0) return;

    // Crear o actualizar el mensaje de confirmación
    let messageEl = document.getElementById('cyclic-assignment-message');
    if (!messageEl) {
      messageEl = document.createElement('div');
      messageEl.id = 'cyclic-assignment-message';
      messageEl.className = 'fixed top-4 left-4 bg-petrol-500 text-white px-4 py-2 rounded-lg shadow-lg z-50 transform transition-all duration-300';

      // Insertar después del header
      const header = document.querySelector('header');
      if (header) {
        header.parentNode.insertBefore(messageEl, header.nextSibling);
      } else {
        document.body.appendChild(messageEl);
      }
    }

    const totalPages = this.config.totalSheets;
    const totalFormats = formatsArray.length;
    const cycles = Math.floor(totalPages / 2 / totalFormats);
    const remaining = (totalPages / 2) % totalFormats;

    let messageText = `Formatos asignados cíclicamente: ${totalFormats} formatos → ${totalPages} páginas`;
    if (cycles > 0) {
      messageText += ` (${cycles} ciclos completos`;
      if (remaining > 0) {
        messageText += ` + ${remaining} páginas adicionales`;
      }
      messageText += ')';
    }

    messageEl.textContent = messageText;
    messageEl.style.transform = 'translateX(0)';
    messageEl.style.opacity = '1';

    // Ocultar el mensaje después de 5 segundos
    setTimeout(() => {
      messageEl.style.transform = 'translateX(-100%)';
      messageEl.style.opacity = '0';
    }, 5000);
  }

  getPageFormatInfo(page) {
    const formatOptions = document.querySelectorAll('.sheet-format-option');
    const formatsArray = Array.from(formatOptions);

    if (formatsArray.length === 0) return null;

    const formatIndex = (page - 1) / 2 % formatsArray.length;
    const format = formatsArray[formatIndex];
    const selectedFormat = this.selectedFormats[page];

    return {
      page,
      formatIndex: formatIndex + 1,
      totalFormats: formatsArray.length,
      assignedFormat: selectedFormat,
      formatElement: format,
      cycleNumber: Math.floor((page - 1) / 2 / formatsArray.length) + 1,
      positionInCycle: ((page - 1) / 2 % formatsArray.length) + 1
    };
  }

  selectSheetFormat(option) {
    // Remover selección anterior
    document.querySelectorAll('.sheet-format-option').forEach(opt => {
      opt.classList.remove('border-petrol-500', 'bg-petrol-50', 'ring-2', 'ring-petrol-500');
      opt.classList.add('border-gray-300');
    });

    // Seleccionar nuevo formato
    option.classList.remove('border-gray-300');
    option.classList.add('border-petrol-500', 'bg-petrol-50', 'ring-2', 'ring-petrol-500');

    // Actualizar información del formato seleccionado
    const formatInfo = {
      id: option.dataset.sheetId,
      noPhotos: parseInt(option.dataset.noPhotos, 10) || 0,
      fullPage: option.dataset.fullPage === 'true',
      double: option.dataset.double === 'true',
      config: option.dataset.config,
      isCover: option.dataset.isCover === 'true',
      textConfig: this.buildCoverTextConfigFromDataset(option.dataset)
    };

    // Determinar si es un formato de doble página
    const isDoublePageFormat = formatInfo.double === true;

    // Verificar si hay un formato de doble página activo en las páginas visibles
    const leftPageFormat = this.selectedFormats[this.currentPage];
    const rightPageFormat = this.selectedFormats[this.currentPage + 1];
    const hasActiveDoublePage = leftPageFormat && rightPageFormat &&
      leftPageFormat.id === rightPageFormat.id &&
      leftPageFormat.double === true;

    // Determinar qué páginas aplicar el formato
    let pagesToApply = [];

    if (isDoublePageFormat) {
      // Si es formato de doble página, aplicar a ambas páginas visibles
      pagesToApply = [this.currentPage, this.currentPage + 1];
      console.log(`FotobookEditor: Double page format detected, applying to pages ${pagesToApply.join(' and ')}`);
    } else {
      // Si es formato de página individual, aplicar solo a la página seleccionada
      pagesToApply = [this.selectedPage];
      console.log(`FotobookEditor: Single page format detected, applying to page ${this.selectedPage}`);

      // Si había un formato de doble página activo y se está aplicando un formato individual,
      // convertir la otra página a formato individual con página completa
      if (hasActiveDoublePage) {
        console.log(`FotobookEditor: Breaking double page format, converting other page to individual full page`);
        this.convertOtherPageToIndividual(this.selectedPage);
      }
    }

    // Aplicar el formato a las páginas correspondientes
    pagesToApply.forEach(page => {
      if (page <= this.config.totalSheets) {
        this.selectedFormats[page] = formatInfo;
        console.log(`FotobookEditor: Applied format to page ${page}:`, formatInfo);
      }
    });

    // Actualizar información del formato seleccionado
    console.log(`${formatInfo.noPhotos} foto(s) - Página ${this.selectedPage}`);
    if (isDoublePageFormat) {
      console.log(`${formatInfo.noPhotos} foto(s) - Páginas ${pagesToApply.join(' y ')} (doble página)`);
    } else {
      console.log(`${formatInfo.noPhotos} foto(s) - Página ${this.selectedPage}`);
    }

    // Actualizar vista previa de doble página
    this.updateDoublePagePreview(this.selectedFormats[this.currentPage]);

    // Actualizar indicadores de las páginas del libro
    this.updateBookPageIndicators();

    // Actualizar tooltips de las páginas
    this.updatePageTooltips();

    // Actualizar información de selección
    // Mostrar mensaje de confirmación
    if (isDoublePageFormat) {
      console.log(`páginas ${pagesToApply.join(' y ')}`, formatInfo.noPhotos, 'success');
    } else {
      console.log(this.selectedPage, formatInfo.noPhotos, 'success');
    }
  }

  selectCoverFormat(option) {
    console.log('FotobookEditor: Selecting cover format');
    console.log('FotobookEditor: Cover option dataset:', option.dataset);

    // Remover selección visual de todos los formatos de covers
    document.querySelectorAll('.cover-format-option').forEach(opt => {
      opt.classList.remove('border-petrol-500', 'bg-petrol-50', 'ring-2', 'ring-petrol-500');
      opt.classList.add('border-gray-300');
    });

    // Seleccionar visualmente el formato clickeado
    option.classList.remove('border-gray-300');
    option.classList.add('border-petrol-500', 'bg-petrol-50', 'ring-2', 'ring-petrol-500');

    // Actualizar información del formato de portada seleccionado
    const coverFormatInfo = {
      id: option.dataset.coverId,
      noPhotos: parseInt(option.dataset.noPhotos, 10) || 0,
      config: option.dataset.config,
      coverTitle: option.dataset.coverTitle,
      coverSubtitle: option.dataset.coverSubtitle,
      coverTitleX: parseFloat(option.dataset.coverTitleX) || 0.5,
      coverTitleY: parseFloat(option.dataset.coverTitleY) || 0.3,
      coverTitleSize: parseFloat(option.dataset.coverTitleSize) || 0.1,
      coverSubtitleX: parseFloat(option.dataset.coverSubtitleX) || 0.5,
      coverSubtitleY: parseFloat(option.dataset.coverSubtitleY) || 0.4,
      coverSubtitleSize: parseFloat(option.dataset.coverSubtitleSize) || 0.05,
      fontFamilies: option.dataset.fontFamilies,
      palette: option.dataset.palette
    };

    this.selectedCoverFormat = coverFormatInfo;
    console.log('FotobookEditor: Selected cover format:', coverFormatInfo);

    // Actualizar vista previa de portadas
    this.updateCoverPreview(coverFormatInfo);

    // No se actualizan indicadores de selección - las portadas no son seleccionables

    // Actualizar el CoverSelector si existe
    if (window.coverSelector && coverFormatInfo.id) {
      window.coverSelector.selectCover(coverFormatInfo.id);
    } else if (window.coverSelector) {
      // Si CoverSelector existe pero no se pudo seleccionar, actualizar manualmente
      const cover = window.COVER_CONFIG?.covers?.find(c => String(c.id) === String(coverFormatInfo.id));
      if (cover) {
        window.coverSelector.updatePalette(cover);
        window.coverSelector.updateFonts(cover);
        window.coverSelector.updateCoverPreview(cover);
      }
    }

    // Actualizar inputs de título y subtítulo si existen
    const titleInput = document.getElementById('cover-title');
    const subtitleInput = document.getElementById('cover-subtitle');
    if (titleInput && coverFormatInfo.coverTitle) {
      titleInput.value = coverFormatInfo.coverTitle;
    }
    if (subtitleInput && coverFormatInfo.coverSubtitle) {
      subtitleInput.value = coverFormatInfo.coverSubtitle;
    }
  }

  updateCoverPreview(coverFormatInfo) {
    console.log('FotobookEditor: Updating cover preview with format:', coverFormatInfo);
    
    const leftCoverSheet = document.getElementById('cover-left-sheet-preview');

    if (!leftCoverSheet) {
      console.log('FotobookEditor: Cover sheet not found for preview update');
      return;
    }

    // Actualizar SVG de portada izquierda
    const leftSvg = leftCoverSheet.querySelector('svg');
    if (leftSvg && coverFormatInfo.config) {
      this.renderCoverSVG(leftSvg, coverFormatInfo, 'left');
    }

    // La contraportada NO se actualiza, solo mantiene el logo y el color de fondo
    // El color de fondo se actualiza desde CoverSelector.setBackgroundColor()
  }

  renderCoverSVG(svgElement, coverFormatInfo, side) {
    // Limpiar contenido previo excepto el rect de fondo
    const bgRect = svgElement.querySelector('rect');
    const existingContent = svgElement.querySelector('g.cover-sheet-content');
    if (existingContent) {
      existingContent.remove();
    }

    // Crear nuevo grupo de contenido
    const contentGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    contentGroup.setAttribute('class', 'cover-sheet-content');

    // Renderizar layout de fotos basado en config
    if (coverFormatInfo.config) {
      this.renderCoverLayout(contentGroup, coverFormatInfo.config, svgElement);
    }

    // Renderizar texto de portada
    this.renderCoverText(contentGroup, coverFormatInfo, side);

    svgElement.appendChild(contentGroup);
  }

  renderCoverLayout(contentGroup, config, svgElement) {
    // Parsear y renderizar el layout de fotos (similar a sheets pero para covers)
    if (!config) return;

    const shapes = config.split('|');
    shapes.forEach((shapeData, index) => {
      const shapeMatch = shapeData.trim().match(/^([rc]):([\d.]+),([\d.]+),([\d.]+),([\d.]+)$/);
      if (!shapeMatch) return;

      const [, type, width, height, x, y] = shapeMatch;
      const svgWidth = parseFloat(svgElement.getAttribute('viewBox').split(' ')[2]);
      const svgHeight = parseFloat(svgElement.getAttribute('viewBox').split(' ')[3]);

      const shapeElement = type === 'r' 
        ? document.createElementNS('http://www.w3.org/2000/svg', 'rect')
        : document.createElementNS('http://www.w3.org/2000/svg', 'circle');

      if (type === 'r') {
        shapeElement.setAttribute('x', parseFloat(x) * svgWidth);
        shapeElement.setAttribute('y', parseFloat(y) * svgHeight);
        shapeElement.setAttribute('width', parseFloat(width) * svgWidth);
        shapeElement.setAttribute('height', parseFloat(height) * svgHeight);
      } else {
        const radius = (parseFloat(width) * svgWidth) / 2;
        shapeElement.setAttribute('r', radius);
        shapeElement.setAttribute('cx', parseFloat(x) * svgWidth + radius);
        shapeElement.setAttribute('cy', parseFloat(y) * svgHeight + radius);
      }

      shapeElement.setAttribute('fill', 'none');
      shapeElement.setAttribute('stroke', '#55859a');
      shapeElement.setAttribute('stroke-width', '1');
      shapeElement.setAttribute('class', 'cover-photo-slot');
      shapeElement.setAttribute('data-slot-index', index);

      contentGroup.appendChild(shapeElement);
    });
  }

  renderCoverText(contentGroup, coverFormatInfo, side) {
    const svgElement = contentGroup.closest('svg');
    if (!svgElement) return;

    const svgWidth = parseFloat(svgElement.getAttribute('viewBox').split(' ')[2]);
    const svgHeight = parseFloat(svgElement.getAttribute('viewBox').split(' ')[3]);

    // Obtener valores de alineación del cover desde COVER_CONFIG
    const cover = window.COVER_CONFIG?.covers?.find(c => String(c.id) === String(coverFormatInfo.id));
    const titleAlign = cover?.title_align || 'center';
    const subtitleAlign = cover?.subtitle_align || 'center';

    // Calcular posición X según alineación
    const calculateTextX = (align, width) => {
      switch (align) {
        case 'left':
          return width * 0.1;
        case 'right':
          return width * 0.9;
        default: // center
          return width * 0.5;
      }
    };

    const getTextAnchor = (align) => {
      switch (align) {
        case 'left':
          return 'start';
        case 'right':
          return 'end';
        default: // center
          return 'middle';
      }
    };

    // Renderizar título
    if (coverFormatInfo.coverTitle) {
      const titleX = calculateTextX(titleAlign, svgWidth);
      const titleText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      titleText.setAttribute('x', titleX);
      titleText.setAttribute('y', coverFormatInfo.coverTitleY * svgHeight);
      titleText.setAttribute('text-anchor', getTextAnchor(titleAlign));
      titleText.setAttribute('dominant-baseline', 'middle');
      titleText.setAttribute('font-size', coverFormatInfo.coverTitleSize * svgHeight);
      titleText.setAttribute('fill', side === 'left' ? '#FFF' : '#15803d');
      titleText.setAttribute('font-weight', 'bold');
      titleText.setAttribute('id', `cover-${side}-sheet-title-text`);
      if (coverFormatInfo.fontFamilies) {
        titleText.setAttribute('font-family', `'${coverFormatInfo.fontFamilies.split(',')[0].trim()}', sans-serif`);
      }
      titleText.textContent = coverFormatInfo.coverTitle;
      contentGroup.appendChild(titleText);
    }

    // Renderizar subtítulo
    if (coverFormatInfo.coverSubtitle) {
      const subtitleX = calculateTextX(subtitleAlign, svgWidth);
      const subtitleText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      subtitleText.setAttribute('x', subtitleX);
      subtitleText.setAttribute('y', coverFormatInfo.coverSubtitleY * svgHeight);
      subtitleText.setAttribute('text-anchor', getTextAnchor(subtitleAlign));
      subtitleText.setAttribute('dominant-baseline', 'middle');
      subtitleText.setAttribute('font-size', coverFormatInfo.coverSubtitleSize * svgHeight);
      subtitleText.setAttribute('fill', '#374151');
      subtitleText.setAttribute('id', `cover-${side}-sheet-subtitle-text`);
      if (coverFormatInfo.fontFamilies) {
        subtitleText.setAttribute('font-family', `'${coverFormatInfo.fontFamilies.split(',')[0].trim()}', sans-serif`);
      }
      subtitleText.textContent = coverFormatInfo.coverSubtitle;
      contentGroup.appendChild(subtitleText);
    }
  }

  convertOtherPageToIndividual(selectedPage) {
    // Determinar cuál es la otra página (la que no fue seleccionada)
    const otherPage = selectedPage === this.currentPage ? this.currentPage + 1 : this.currentPage;

    // Verificar que la otra página existe
    if (otherPage > this.config.totalSheets) {
      console.log(`FotobookEditor: Other page ${otherPage} does not exist`);
      return;
    }

    // Buscar un formato de página completa individual
    const formatOptions = document.querySelectorAll('.sheet-format-option');
    let individualFullPageFormat = null;

    for (let option of formatOptions) {
      const isDouble = option.dataset.double === 'true';
      const isFullPage = option.dataset.fullPage === 'true';

      // Buscar un formato que sea de página completa pero no de doble página
      if (!isDouble && isFullPage) {
        individualFullPageFormat = {
          id: option.dataset.sheetId,
          noPhotos: parseInt(option.dataset.noPhotos, 10) || 0,
          fullPage: true,
          double: false,
          config: option.dataset.config,
          isCover: option.dataset.isCover === 'true',
          textConfig: this.buildCoverTextConfigFromDataset(option.dataset)
        };
        break;
      }
    }

    // Si no se encuentra un formato de página completa, usar el primer formato individual disponible
    if (!individualFullPageFormat) {
      for (let option of formatOptions) {
        const isDouble = option.dataset.double === 'true';
        if (!isDouble) {
        individualFullPageFormat = {
          id: option.dataset.sheetId,
          noPhotos: parseInt(option.dataset.noPhotos, 10) || 0,
          fullPage: option.dataset.fullPage === 'true',
          double: false,
          config: option.dataset.config,
          isCover: option.dataset.isCover === 'true',
          textConfig: this.buildCoverTextConfigFromDataset(option.dataset)
          };
          break;
        }
      }
    }

    // Aplicar el formato individual a la otra página
    if (individualFullPageFormat) {
      this.selectedFormats[otherPage] = individualFullPageFormat;
      console.log(`FotobookEditor: Converted page ${otherPage} to individual format:`, individualFullPageFormat);
    } else {
      console.log(`FotobookEditor: No suitable individual format found for page ${otherPage}`);
    }
  }

  updateDoublePagePreview(formatInfo) {
    const leftPreview = document.getElementById('left-sheet-preview');
    const rightPreview = document.getElementById('right-sheet-preview');

    if (!leftPreview || !rightPreview) {
      console.error('FotobookEditor: Left or right preview not found');
      return;
    }

    // Obtener el SVG completo, no solo el grupo page-content
    const leftSvg = leftPreview.querySelector('svg');
    const rightSvg = rightPreview.querySelector('svg');

    if (!leftSvg || !rightSvg) {
      console.error('FotobookEditor: Left or right SVG not found');
      return;
    }

    // Verificar si la página derecha existe
    const rightPageExists = (this.currentPage + 1) <= this.config.totalSheets;
    const rightPageNumber = this.currentPage + 1;

    // Obtener formato para la página izquierda (página actual)
    const leftPageFormat = formatInfo;

    // Obtener formato para la página derecha (si existe)
    const rightPageFormat = rightPageExists ? this.selectedFormats[rightPageNumber] : null;

    // Renderizar página izquierda
    if (leftPageFormat && leftPageFormat.config) {
      try {
        const leftLayoutData = this.parseLayoutData(leftPageFormat.config);
        if (leftLayoutData) {
          console.log('FotobookEditor: updateDoublePagePreview - leftPageFormat:', leftPageFormat);
          console.log('FotobookEditor: updateDoublePagePreview - leftPageFormat.isCover:', leftPageFormat.isCover);
          console.log('FotobookEditor: updateDoublePagePreview - leftPageFormat.textConfig:', leftPageFormat.textConfig);
          const leftPreviewOptions = leftPageFormat && leftPageFormat.textConfig ? { textConfig: leftPageFormat.textConfig } : undefined;
          console.log('FotobookEditor: updateDoublePagePreview - leftPreviewOptions:', leftPreviewOptions);
          const generatedSVG = this.generateSVGPreview(leftLayoutData, undefined, undefined, leftPreviewOptions);
          console.log('FotobookEditor: updateDoublePagePreview - generatedSVG length:', generatedSVG.length);
          console.log('FotobookEditor: updateDoublePagePreview - generatedSVG includes text:', generatedSVG.includes('<text'));
          leftSvg.outerHTML = generatedSVG;
        } else {
          leftSvg.outerHTML = this.generateDefaultSVG();
        }
      } catch (e) {
        console.error('Error parsing left page layout data:', e);
        leftSvg.outerHTML = this.generateDefaultSVG();
      }
    } else {
      leftSvg.outerHTML = this.generateDefaultSVG();
    }

    // Reaplicar fotos colocadas en la página izquierda
    const newLeftSvg = leftPreview.querySelector('svg');
    if (newLeftSvg) {
      this.applyPlacedPhotosToPage(newLeftSvg, this.currentPage);
    }

    // Renderizar página derecha
    if (rightPageExists) {
      if (rightPageFormat && rightPageFormat.config) {
        try {
          const rightLayoutData = this.parseLayoutData(rightPageFormat.config);
          if (rightLayoutData) {
            const rightPreviewOptions = rightPageFormat && rightPageFormat.textConfig ? { textConfig: rightPageFormat.textConfig } : undefined;
            rightSvg.outerHTML = this.generateSVGPreview(rightLayoutData, undefined, undefined, rightPreviewOptions);
          } else {
            rightSvg.outerHTML = this.generateDefaultSVG();
          }
        } catch (e) {
          console.error('Error parsing right page layout data:', e);
          rightSvg.outerHTML = this.generateDefaultSVG();
        }
      } else {
        rightSvg.outerHTML = this.generateDefaultSVG();
      }

      // Reaplicar fotos colocadas en la página derecha
      const newRightSvg = rightPreview.querySelector('svg');
      if (newRightSvg) {
        this.applyPlacedPhotosToPage(newRightSvg, rightPageNumber);
      }
    } else {
      rightSvg.outerHTML = `
        <div class="flex items-center justify-center h-full">
          <div class="text-center text-gray-500">
            <i class="fas fa-times text-4xl mb-2"></i>
            <p class="text-sm">Sin página</p>
          </div>
        </div>
      `;
    }
  }

  applyPlacedPhotosToPage(svg, pageNumber) {
    if (!svg) return;
    const placedForPage = this.placedPhotos[pageNumber];
    if (!placedForPage) return;

    Object.entries(placedForPage).forEach(([slotIndex, data]) => {
      const slotGroup = svg.querySelector(`g.photo-slot[data-slot-index="${slotIndex}"]`);
      const slotRect = svg.querySelector(`.photo-slot-rect[data-slot-index="${slotIndex}"]`);
      if (!slotGroup || !slotRect) return;

      const x = parseFloat(slotRect.getAttribute('x'));
      const y = parseFloat(slotRect.getAttribute('y'));
      const w = parseFloat(slotRect.getAttribute('width'));
      const h = parseFloat(slotRect.getAttribute('height'));

      // Si ya hay imagen, saltar
      const prevImg = slotGroup.querySelector('image');
      if (prevImg) return;

      const imgEl = document.createElementNS('http://www.w3.org/2000/svg', 'image');
      imgEl.setAttributeNS('http://www.w3.org/1999/xlink', 'href', data.url);
      imgEl.setAttribute('x', String(x));
      imgEl.setAttribute('y', String(y));
      imgEl.setAttribute('width', String(w));
      imgEl.setAttribute('height', String(h));
      imgEl.setAttribute('preserveAspectRatio', 'xMidYMid slice');
      imgEl.setAttribute('data-file-index', String(data.fileIndex));
      slotGroup.appendChild(imgEl);
    });
  }

  showDefaultDoublePage(leftContent, rightContent, rightPageExists) {
    leftContent.innerHTML = this.generateDefaultSVG();
    if (rightPageExists) {
      rightContent.innerHTML = this.generateDefaultSVG();
    } else {
      rightContent.innerHTML = this.generateDefaultSVG();
    }
  }

  showErrorDoublePage(leftContent, rightContent) {
    leftContent.innerHTML = this.generateDefaultSVG();
    rightContent.innerHTML = this.generateDefaultSVG();
  }

  generateSVGPreview(layoutData, width, height, options = {}) {
    if (!Array.isArray(layoutData)) {
      return this.generateDefaultSVG(width, height);
    }

    // Usar dimensiones reales de página si no se especifican
    const realDimensions = this.getRealPageDimensions();
    const actualWidth = width || realDimensions.width;
    const actualHeight = height || realDimensions.height;

    console.log(`FotobookEditor: Generating SVG preview with dimensions ${actualWidth}x${actualHeight}`);

    // Debug: verificar cálculos de posición
    this.debugPositionCalculation(layoutData, actualWidth, actualHeight);

    // Validar y ajustar el formato si es necesario
    const adjustedLayoutData = this.validateAndAdjustFormat(layoutData, actualWidth, actualHeight);

    const photoElements = adjustedLayoutData.map((photo, index) => {
      // Los valores x, y están en el centro de la foto, no en la esquina
      // Necesitamos calcular la esquina superior izquierda
      const photoWidth = photo.width * actualWidth / 100;
      const photoHeight = photo.height * actualHeight / 100;
      const centerX = photo.x * actualWidth / 100;
      const centerY = photo.y * actualHeight / 100;

      // Calcular la esquina superior izquierda desde el centro
      const x = centerX - (photoWidth / 2);
      const y = centerY - (photoHeight / 2);

      return `
        <g class="photo-slot" data-slot-index="${index}">
          <rect x="${x}" y="${y}" width="${photoWidth}" height="${photoHeight}"
                class="photo-slot-rect" data-slot-index="${index}" rx="2"/>
        </g>
      `;
    }).join('');

    const textConfig = options && options.textConfig ? options.textConfig : null;
    console.log('FotobookEditor: generateSVGPreview - textConfig:', textConfig);
    const coverTextElements = this.generateCoverTextElements(textConfig, actualWidth, actualHeight);
    console.log('FotobookEditor: generateSVGPreview - coverTextElements:', coverTextElements);

    return `
      <svg class="w-full h-full" viewBox="0 0 ${actualWidth} ${actualHeight}" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
        <rect width="100%" height="100%" fill="#ffffff" stroke="#55859a" stroke-width="2"/>
        ${photoElements}
        ${coverTextElements}
      </svg>
    `;
  }

  generateDefaultSVG(width, height) {
    // Usar dimensiones reales de página si no se especifican
    const realDimensions = this.getRealPageDimensions();
    const actualWidth = width || realDimensions.width;
    const actualHeight = height || realDimensions.height;

    console.log(`FotobookEditor: Generating default SVG with dimensions ${actualWidth}x${actualHeight}`);

    return `
      <svg class="w-full h-full" viewBox="0 0 ${actualWidth} ${actualHeight}" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
        <rect width="100%" height="100%" fill="#ffffff" stroke="#55859a" stroke-width="1"/>
      </svg>
    `;
  }

  generateCoverTextElements(textConfig, pageWidth, pageHeight) {
    console.log('FotobookEditor: generateCoverTextElements called with:', {
      textConfig,
      pageWidth,
      pageHeight,
      isCover: textConfig?.isCover
    });

    if (!textConfig || textConfig.isCover !== true) {
      console.log('FotobookEditor: No text config or not a cover, returning empty');
      return '';
    }

    const elements = [];

    // Verificar que title existe y tiene contenido
    if (textConfig.title) {
      const titleElement = this.buildSVGTextElement(textConfig.title, {
        fill: '#1f2937',
        fontWeight: 'bold'
      }, pageWidth, pageHeight);

      if (titleElement && titleElement.trim() !== '') {
        elements.push(titleElement);
        console.log('FotobookEditor: Title element created:', titleElement);
      } else {
        console.log('FotobookEditor: Title element not created - empty or invalid');
      }
    } else {
      console.log('FotobookEditor: Title config missing');
    }

    // Verificar que subtitle existe y tiene contenido
    if (textConfig.subtitle) {
      const subtitleElement = this.buildSVGTextElement(textConfig.subtitle, {
        fill: '#4b5563'
      }, pageWidth, pageHeight);

      if (subtitleElement && subtitleElement.trim() !== '') {
        elements.push(subtitleElement);
        console.log('FotobookEditor: Subtitle element created:', subtitleElement);
      } else {
        console.log('FotobookEditor: Subtitle element not created - empty or invalid');
      }
    } else {
      console.log('FotobookEditor: Subtitle config missing');
    }

    if (elements.length === 0) {
      console.log('FotobookEditor: No text elements created, returning empty');
      return '';
    }

    // El grupo de texto debe renderizarse DESPUÉS de las fotos para estar encima
    const result = `
      <g class="cover-text-layer" style="pointer-events: none;">
        ${elements.join('\n        ')}
      </g>
    `;
    console.log('FotobookEditor: Generated cover text elements:', result);
    return result;
  }

  buildSVGTextElement(config, style, pageWidth, pageHeight) {
    if (!config) {
      return '';
    }

    const x = this.clampRelativeValue(config.x, 0, 1) * pageWidth;
    const y = this.clampRelativeValue(config.y, 0, 1) * pageHeight;
    const baseSize = Math.min(pageWidth, pageHeight);
    let fontSize = this.ensurePositiveSize(config.size) * baseSize;
    
    // Asegurar un tamaño mínimo de fuente para visibilidad
    const minFontSize = Math.max(12, baseSize * 0.03); // Mínimo 12px o 3% del tamaño base
    fontSize = Math.max(fontSize, minFontSize);
    
    const textContent = this.escapeSVGText(config.text || '');
    const fontFamily = style && style.fontFamily ? style.fontFamily : 'Arial, sans-serif';
    const fill = style && style.fill ? style.fill : '#1f2937';
    const fontWeight = style && style.fontWeight ? style.fontWeight : 'normal';

    if (!textContent || textContent.trim() === '') {
      console.log('FotobookEditor: buildSVGTextElement - Empty text content, returning empty');
      return '';
    }

    // Asegurar que el texto sea visible con un stroke sutil para contraste
    const strokeWidth = Math.max(1, fontSize * 0.02);
    
    console.log('FotobookEditor: buildSVGTextElement - Creating text:', {
      text: textContent,
      x,
      y,
      fontSize,
      fill,
      pageWidth,
      pageHeight
    });
    
    return `
      <text x="${x}" y="${y}" text-anchor="middle" dominant-baseline="middle"
            font-size="${fontSize}" fill="${fill}" font-family="${fontFamily}" font-weight="${fontWeight}"
            stroke="rgba(255, 255, 255, 0.8)" stroke-width="${strokeWidth}" stroke-linejoin="round"
            paint-order="stroke fill">
        ${textContent}
      </text>
    `;
  }

  clampRelativeValue(value, min = 0, max = 1) {
    if (!Number.isFinite(value)) {
      return Math.min(Math.max(0.5, min), max);
    }
    return Math.min(Math.max(value, min), max);
  }

  ensurePositiveSize(value) {
    if (!Number.isFinite(value) || value <= 0) {
      return 0.06;
    }
    return value;
  }

  buildCoverTextConfigFromDataset(dataset) {
    if (!dataset || dataset.isCover !== 'true') {
      return null;
    }

    // Los atributos data-* se convierten a camelCase en dataset
    // data-cover-title -> dataset.coverTitle
    // data-cover-title-x -> dataset.coverTitleX
    const titleText = (dataset.coverTitle && dataset.coverTitle.trim() !== '') ? dataset.coverTitle : 'Keep the moment';
    const titleX = dataset.coverTitleX ? parseFloat(dataset.coverTitleX) : 0.5;
    const titleY = dataset.coverTitleY ? parseFloat(dataset.coverTitleY) : 0.15;
    const titleSize = dataset.coverTitleSize ? parseFloat(dataset.coverTitleSize) : 0.08;

    const subtitleText = (dataset.coverSubtitle && dataset.coverSubtitle.trim() !== '') ? dataset.coverSubtitle : 'Print it';
    const subtitleX = dataset.coverSubtitleX ? parseFloat(dataset.coverSubtitleX) : 0.5;
    const subtitleY = dataset.coverSubtitleY ? parseFloat(dataset.coverSubtitleY) : 0.85;
    const subtitleSize = dataset.coverSubtitleSize ? parseFloat(dataset.coverSubtitleSize) : 0.06;

    console.log('FotobookEditor: Building cover text config from dataset:', {
      isCover: dataset.isCover,
      titleText,
      titleX,
      titleY,
      titleSize,
      subtitleText,
      subtitleX,
      subtitleY,
      subtitleSize
    });

    return {
      isCover: true,
      title: this.buildTextLayerConfig({
        text: titleText,
        x: titleX,
        y: titleY,
        size: titleSize
      }, { text: 'Keep the moment', x: 0.5, y: 0.15, size: 0.08 }),
      subtitle: this.buildTextLayerConfig({
        text: subtitleText,
        x: subtitleX,
        y: subtitleY,
        size: subtitleSize
      }, { text: 'Print it', x: 0.5, y: 0.85, size: 0.06 })
    };
  }

  buildTextLayerConfig(raw = {}, defaults) {
    const textValue = raw.text != null ? String(raw.text) : '';
    const sanitizedText = textValue.trim();

    return {
      text: sanitizedText || defaults.text,
      x: this.parseRelativePosition(raw.x, defaults.x),
      y: this.parseRelativePosition(raw.y, defaults.y),
      size: this.parseRelativeSize(raw.size, defaults.size)
    };
  }

  parseRelativePosition(value, fallback) {
    const num = parseFloat(value);
    return Number.isFinite(num) ? num : fallback;
  }

  parseRelativeSize(value, fallback) {
    const num = parseFloat(value);
    if (!Number.isFinite(num) || num <= 0) {
      return fallback;
    }
    return num;
  }

  escapeSVGText(content) {
    if (content === null || content === undefined) {
      return '';
    }

    return String(content)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  parseLayoutData(config) {
    if (!config || config.trim() === '') {
      return null;
    }

    // Intentar parsear como JSON primero
    try {
      const data = JSON.parse(config);
      return this.normalizeLayoutData(data);
    } catch (e) {
      // Si no es JSON, intentar parsear como string de números separados por comas
      return this.parseCommaSeparatedData(config);
    }
  }

  parseCommaSeparatedData(config) {
    // Formato: "0.8,0.8,0.5,0.25" -> [{"width": 80, "height": 80, "x": 50, "y": 25}]
    // Formato múltiple: ".3,.3,0,.17|.3,.3,.47,.17|.3,.3,.94,.17" -> Array de fotos
    // Los valores representan: width, height, x_center, y_center

    // Verificar si hay múltiples fotos (separadas por |)
    if (config.includes('|')) {
      console.log('FotobookEditor: Parsing multiple photos format');
      const photoConfigs = config.split('|');
      const photos = [];

      photoConfigs.forEach((photoConfig, index) => {
        const numbers = photoConfig.split(',').map(n => parseFloat(n.trim()));
        if (numbers.length >= 4 && !numbers.some(isNaN)) {
          photos.push({
            width: numbers[0] * 100,  // 0.3 -> 30% del ancho
            height: numbers[1] * 100, // 0.3 -> 30% del alto
            x: numbers[2] * 100,      // 0 -> 0% (esquina izquierda)
            y: numbers[3] * 100       // 0.17 -> 17% (centro vertical)
          });
          console.log(`FotobookEditor: Parsed photo ${index + 1}:`, photos[photos.length - 1]);
        } else {
          console.warn(`FotobookEditor: Invalid photo config at index ${index}:`, photoConfig);
        }
      });

      console.log(`FotobookEditor: Total photos parsed: ${photos.length}`);
      return photos.length > 0 ? photos : null;
    } else {
      // Formato de una sola foto (código original)
      const numbers = config.split(',').map(n => parseFloat(n.trim()));
      if (numbers.length < 4 || numbers.some(isNaN)) {
        return null;
      }

      // Los valores están en escala 0-1, convertirlos a porcentajes
      // width, height, x_center, y_center
      return [{
        width: numbers[0] * 100,  // 0.8 -> 80% del ancho
        height: numbers[1] * 100, // 0.8 -> 80% del alto
        x: numbers[2] * 100,      // 0.5 -> 50% (centro horizontal)
        y: numbers[3] * 100       // 0.25 -> 25% (centro vertical)
      }];
    }
  }

  normalizeLayoutData(data) {
    if (!Array.isArray(data)) {
      return null;
    }

    return data.map(photo => {
      if (!photo || typeof photo !== 'object') {
        return null;
      }

      // Normalizar nombres de propiedades
      const normalized = {};
      normalized.width = photo.width || photo.w || 50;
      normalized.height = photo.height || photo.h || 50;
      normalized.x = photo.x || 25;  // Centro horizontal por defecto
      normalized.y = photo.y || 25;  // Centro vertical por defecto

      // Convertir a porcentajes si están en formato decimal (0-1)
      if (normalized.width <= 1) {
        normalized.width *= 100;
        normalized.height *= 100;
        normalized.x *= 100;
        normalized.y *= 100;
      }

      // Asegurar que x, y representen el centro de la foto
      // Los valores ya están en el centro, no necesitan ajuste adicional

      return normalized;
    }).filter(Boolean);
  }

  debugPositionCalculation(layoutData, width, height) {
    console.log('FotobookEditor: Debug position calculation');
    console.log('Layout data:', layoutData);
    console.log('Canvas dimensions:', { width, height });

    if (Array.isArray(layoutData)) {
      layoutData.forEach((photo, index) => {
        const photoWidth = photo.width * width / 100;
        const photoHeight = photo.height * height / 100;
        const centerX = photo.x * width / 100;
        const centerY = photo.y * height / 100;
        const x = centerX - (photoWidth / 2);
        const y = centerY - (photoHeight / 2);

        console.log(`Photo ${index + 1}:`, {
          original: { width: photo.width, height: photo.height, x: photo.x, y: photo.y },
          calculated: { photoWidth, photoHeight, centerX, centerY, x, y }
        });
      });
    }
  }

  testPositionCalculation() {
    console.log('FotobookEditor: Testing position calculation with example');

    // Ejemplo: "0.8,0.8,0.5,0.25" -> width: 80%, height: 80%, x: 50%, y: 25%
    const testConfig = "0.8,0.8,0.5,0.25";
    const layoutData = this.parseLayoutData(testConfig);
    const width = 100;  // Cambiar a 100x100 para mejor visualización
    const height = 100;

    console.log('Test config:', testConfig);
    console.log('Parsed layout data:', layoutData);

    if (layoutData) {
      this.debugPositionCalculation(layoutData, width, height);

      // Verificar que la foto esté centrada correctamente
      const photo = layoutData[0];
      const photoWidth = photo.width * width / 100;  // 80% de 100 = 80px
      const photoHeight = photo.height * height / 100; // 80% de 100 = 80px
      const centerX = photo.x * width / 100;  // 50% de 100 = 50px
      const centerY = photo.y * height / 100; // 25% de 100 = 25px
      const x = centerX - (photoWidth / 2);   // 50 - 40 = 10px
      const y = centerY - (photoHeight / 2);  // 25 - 40 = -15px

      console.log('=== ANÁLISIS EN HOJA 100x100px ===');
      console.log('Datos del formato "0.8,0.8,0.5,0.25":');
      console.log('- Ancho de foto: 80px (80% de 100px)');
      console.log('- Alto de foto: 80px (80% de 100px)');
      console.log('- Centro X: 50px (50% de 100px)');
      console.log('- Centro Y: 25px (25% de 100px)');
      console.log('- Esquina X: 10px (50 - 40)');
      console.log('- Esquina Y: -15px (25 - 40) ❌ PROBLEMA: Sale de la página');

      // Verificar si la foto cabe en la página
      const fitsInPage = x >= 0 && y >= 0 && (x + photoWidth) <= width && (y + photoHeight) <= height;
      console.log('¿La foto cabe en la página?', fitsInPage ? '✅ SÍ' : '❌ NO');

      if (!fitsInPage) {
        console.log('PROBLEMA: La foto sale de los límites de la página');
        console.log('Límites de la página: 0,0 a 100,100');
        console.log('Límites de la foto: ' + x + ',' + y + ' a ' + (x + photoWidth) + ',' + (y + photoHeight));
      }

      console.log('Expected calculations:', {
        photoWidth: 80,
        photoHeight: 80,
        centerX: 50,
        centerY: 25,
        x: 10,
        y: -15
      });

      console.log('Actual calculations:', {
        photoWidth,
        photoHeight,
        centerX,
        centerY,
        x,
        y
      });
    }
  }

  testMultiplePhotosFormat() {
    console.log('FotobookEditor: Testing multiple photos format');

    // Ejemplo del formato proporcionado
    const testConfig = ".3,.3,0,.17|.3,.3,.47,.17|.3,.3,.94,.17|.3,.3,.06,.83|.3,.3,.53,.83|.3,.3,1,.83";
    const layoutData = this.parseLayoutData(testConfig);
    const width = 100;
    const height = 100;

    console.log('Test config (multiple photos):', testConfig);
    console.log('Parsed layout data:', layoutData);

    if (layoutData && Array.isArray(layoutData)) {
      console.log(`\n=== ANÁLISIS DE ${layoutData.length} FOTOS EN HOJA 100x100px ===`);

      layoutData.forEach((photo, index) => {
        const photoWidth = photo.width * width / 100;
        const photoHeight = photo.height * height / 100;
        const centerX = photo.x * width / 100;
        const centerY = photo.y * height / 100;
        const x = centerX - (photoWidth / 2);
        const y = centerY - (photoHeight / 2);

        const fitsInPage = x >= 0 && y >= 0 && (x + photoWidth) <= width && (y + photoHeight) <= height;

        console.log(`\n📷 Foto ${index + 1}:`);
        console.log(`   Tamaño: ${photoWidth.toFixed(1)}x${photoHeight.toFixed(1)}px (${photo.width}%x${photo.height}%)`);
        console.log(`   Centro: (${centerX.toFixed(1)}, ${centerY.toFixed(1)}) (${photo.x}%, ${photo.y}%)`);
        console.log(`   Esquina: (${x.toFixed(1)}, ${y.toFixed(1)}) a (${(x + photoWidth).toFixed(1)}, ${(y + photoHeight).toFixed(1)})`);
        console.log(`   ¿Cabe?: ${fitsInPage ? '✅ SÍ' : '❌ NO'}`);

        if (!fitsInPage) {
          console.log(`   ❌ PROBLEMA: Foto ${index + 1} sale de los límites`);
        }
      });

      // Verificar si todas las fotos caben
      const allFit = layoutData.every((photo, index) => {
        const photoWidth = photo.width * width / 100;
        const photoHeight = photo.height * height / 100;
        const centerX = photo.x * width / 100;
        const centerY = photo.y * height / 100;
        const x = centerX - (photoWidth / 2);
        const y = centerY - (photoHeight / 2);
        return x >= 0 && y >= 0 && (x + photoWidth) <= width && (y + photoHeight) <= height;
      });

      console.log(`\n🎯 RESULTADO GENERAL:`);
      console.log(`   ¿Todas las fotos caben?: ${allFit ? '✅ SÍ' : '❌ NO'}`);
      console.log(`   Total de fotos: ${layoutData.length}`);
    }
  }

  analyzeMultiplePhotosLayout() {
    console.log('\n📸 ANÁLISIS DE LAYOUTS DE MÚLTIPLES FOTOS:');
    console.log('============================================');

    const pageWidth = 100;
    const pageHeight = 100;

    // Ejemplo 1: Layout 2x3 (6 fotos)
    console.log('\n📋 LAYOUT 2x3 (6 fotos):');
    const layout2x3 = ".3,.3,0,.17|.3,.3,.47,.17|.3,.3,.94,.17|.3,.3,.06,.83|.3,.3,.53,.83|.3,.3,1,.83";
    this.analyzeMultiplePhotosFormat(layout2x3, pageWidth, pageHeight, "2x3 Grid");

    // Ejemplo 2: Layout 2x2 (4 fotos)
    console.log('\n📋 LAYOUT 2x2 (4 fotos):');
    const layout2x2 = ".4,.4,0.25,0.25|.4,.4,0.75,0.25|.4,.4,0.25,0.75|.4,.4,0.75,0.75";
    this.analyzeMultiplePhotosFormat(layout2x2, pageWidth, pageHeight, "2x2 Grid");

    // Ejemplo 3: Layout 3x1 (3 fotos horizontales)
    console.log('\n📋 LAYOUT 3x1 (3 fotos horizontales):');
    const layout3x1 = ".25,.6,0.17,0.5|.25,.6,0.5,0.5|.25,.6,0.83,0.5";
    this.analyzeMultiplePhotosFormat(layout3x1, pageWidth, pageHeight, "3x1 Horizontal");

    // Ejemplo 4: Layout 1x3 (3 fotos verticales)
    console.log('\n📋 LAYOUT 1x3 (3 fotos verticales):');
    const layout1x3 = ".6,.25,0.5,0.17|.6,.25,0.5,0.5|.6,.25,0.5,0.83";
    this.analyzeMultiplePhotosFormat(layout1x3, pageWidth, pageHeight, "1x3 Vertical");
  }

  analyzeMultiplePhotosFormat(config, pageWidth, pageHeight, description) {
    const layoutData = this.parseLayoutData(config);
    if (!layoutData || !Array.isArray(layoutData)) {
      console.log(`   ❌ Error parsing: ${description}`);
      return;
    }

    console.log(`   📸 ${description}:`);
    console.log(`   Config: ${config}`);
    console.log(`   Total fotos: ${layoutData.length}`);

    let allFit = true;
    layoutData.forEach((photo, index) => {
      const photoWidth = photo.width * pageWidth / 100;
      const photoHeight = photo.height * pageHeight / 100;
      const centerX = photo.x * pageWidth / 100;
      const centerY = photo.y * pageHeight / 100;
      const x = centerX - (photoWidth / 2);
      const y = centerY - (photoHeight / 2);

      const fitsInPage = x >= 0 && y >= 0 && (x + photoWidth) <= pageWidth && (y + photoHeight) <= pageHeight;
      if (!fitsInPage) allFit = false;

      console.log(`     Foto ${index + 1}: ${photoWidth.toFixed(1)}x${photoHeight.toFixed(1)}px en (${x.toFixed(1)}, ${y.toFixed(1)}) - ${fitsInPage ? '✅' : '❌'}`);
    });

    console.log(`   Resultado: ${allFit ? '✅ Todas caben' : '❌ Algunas no caben'}`);
  }

  analyzeConfigurationOptions() {
    console.log('FotobookEditor: Analyzing configuration options');

    const pageWidth = 100;
    const pageHeight = 100;

    // Opción 1: Mantener el formato actual pero ajustar Y para que quepa
    console.log('\n=== OPCIÓN 1: Ajustar Y para que quepa ===');
    const option1 = this.analyzeFormat("0.8,0.8,0.5,0.5", pageWidth, pageHeight, "Centrado vertical");

    // Opción 2: Reducir el tamaño para que quepa en cualquier posición
    console.log('\n=== OPCIÓN 2: Reducir tamaño para seguridad ===');
    const option2 = this.analyzeFormat("0.6,0.6,0.5,0.25", pageWidth, pageHeight, "Tamaño reducido");

    // Opción 3: Usar márgenes mínimos
    console.log('\n=== OPCIÓN 3: Márgenes mínimos ===');
    const option3 = this.analyzeFormat("0.9,0.9,0.5,0.5", pageWidth, pageHeight, "Máximo tamaño centrado");

    // Opción 4: Formato original con validación
    console.log('\n=== OPCIÓN 4: Formato original con validación ===');
    const option4 = this.analyzeFormat("0.8,0.8,0.5,0.25", pageWidth, pageHeight, "Original con ajuste");

    // Opción 5: Sistema de coordenadas desde esquina
    console.log('\n=== OPCIÓN 5: Coordenadas desde esquina ===');
    const option5 = this.analyzeFormatFromCorner("0.8,0.8,0.1,0.1", pageWidth, pageHeight, "Desde esquina");

    return { option1, option2, option3, option4, option5 };
  }

  analyzeFormat(config, pageWidth, pageHeight, description) {
    const layoutData = this.parseLayoutData(config);
    if (!layoutData) return null;

    const photo = layoutData[0];
    const photoWidth = photo.width * pageWidth / 100;
    const photoHeight = photo.height * pageHeight / 100;
    const centerX = photo.x * pageWidth / 100;
    const centerY = photo.y * pageHeight / 100;
    const x = centerX - (photoWidth / 2);
    const y = centerY - (photoHeight / 2);

    const fitsInPage = x >= 0 && y >= 0 && (x + photoWidth) <= pageWidth && (y + photoHeight) <= pageHeight;

    console.log(`📋 ${description}:`);
    console.log(`   Config: ${config}`);
    console.log(`   Tamaño: ${photoWidth.toFixed(1)}x${photoHeight.toFixed(1)}px`);
    console.log(`   Posición: (${x.toFixed(1)}, ${y.toFixed(1)}) a (${(x + photoWidth).toFixed(1)}, ${(y + photoHeight).toFixed(1)})`);
    console.log(`   ¿Cabe?: ${fitsInPage ? '✅ SÍ' : '❌ NO'}`);

    if (!fitsInPage) {
      console.log(`   ❌ PROBLEMA: Sale de la página`);
      console.log(`   💡 SUGERENCIA: Ajustar Y a ${(photoHeight / 2 / pageHeight * 100).toFixed(1)}% o más`);
    }

    return { config, fitsInPage, photoWidth, photoHeight, x, y };
  }

  analyzeFormatFromCorner(config, pageWidth, pageHeight, description) {
    // Interpretar como coordenadas desde esquina superior izquierda
    const numbers = config.split(',').map(n => parseFloat(n.trim()));
    if (numbers.length < 4) return null;

    const photoWidth = numbers[0] * pageWidth;  // 0.8 -> 80px
    const photoHeight = numbers[1] * pageHeight; // 0.8 -> 80px
    const x = numbers[2] * pageWidth;  // 0.1 -> 10px (desde izquierda)
    const y = numbers[3] * pageHeight; // 0.1 -> 10px (desde arriba)

    const fitsInPage = x >= 0 && y >= 0 && (x + photoWidth) <= pageWidth && (y + photoHeight) <= pageHeight;

    console.log(`📋 ${description}:`);
    console.log(`   Config: ${config} (desde esquina)`);
    console.log(`   Tamaño: ${photoWidth.toFixed(1)}x${photoHeight.toFixed(1)}px`);
    console.log(`   Posición: (${x.toFixed(1)}, ${y.toFixed(1)}) a (${(x + photoWidth).toFixed(1)}, ${(y + photoHeight).toFixed(1)})`);
    console.log(`   ¿Cabe?: ${fitsInPage ? '✅ SÍ' : '❌ NO'}`);

    return { config, fitsInPage, photoWidth, photoHeight, x, y, fromCorner: true };
  }

  validateAndAdjustFormat(layoutData, pageWidth, pageHeight) {
    if (!Array.isArray(layoutData)) return layoutData;

    return layoutData.map(photo => {
      const photoWidth = photo.width * pageWidth / 100;
      const photoHeight = photo.height * pageHeight / 100;
      const centerX = photo.x * pageWidth / 100;
      const centerY = photo.y * pageHeight / 100;
      const x = centerX - (photoWidth / 2);
      const y = centerY - (photoHeight / 2);

      // Verificar si la foto cabe en la página
      const fitsInPage = x >= 0 && y >= 0 && (x + photoWidth) <= pageWidth && (y + photoHeight) <= pageHeight;

      if (!fitsInPage) {
        console.log('FotobookEditor: Format adjustment needed for photo:', photo);

        // Crear una copia ajustada
        const adjustedPhoto = { ...photo };

        // Ajustar X si sale por los lados
        if (x < 0) {
          // La foto sale por la izquierda, centrarla
          adjustedPhoto.x = (photoWidth / 2 / pageWidth) * 100;
          console.log(`   Ajustado X de ${photo.x}% a ${adjustedPhoto.x}%`);
        } else if (x + photoWidth > pageWidth) {
          // La foto sale por la derecha, centrarla
          adjustedPhoto.x = ((pageWidth - photoWidth / 2) / pageWidth) * 100;
          console.log(`   Ajustado X de ${photo.x}% a ${adjustedPhoto.x}%`);
        }

        // Ajustar Y si sale por arriba o abajo
        if (y < 0) {
          // La foto sale por arriba, centrarla
          adjustedPhoto.y = (photoHeight / 2 / pageHeight) * 100;
          console.log(`   Ajustado Y de ${photo.y}% a ${adjustedPhoto.y}%`);
        } else if (y + photoHeight > pageHeight) {
          // La foto sale por abajo, centrarla
          adjustedPhoto.y = ((pageHeight - photoHeight / 2) / pageHeight) * 100;
          console.log(`   Ajustado Y de ${photo.y}% a ${adjustedPhoto.y}%`);
        }

        return adjustedPhoto;
      }

      return photo;
    });
  }

  showConfigurationRecommendations() {
    console.log('\n🎯 RECOMENDACIONES DE CONFIGURACIÓN:');
    console.log('=====================================');

    console.log('\n📋 OPCIÓN RECOMENDADA 1: Centrado automático');
    console.log('   Formato: "0.8,0.8,0.5,0.5"');
    console.log('   Descripción: Foto 80% del tamaño, centrada en la página');
    console.log('   Ventajas: Siempre cabe, posición predecible');
    console.log('   Uso: Para fotos principales centradas');

    console.log('\n📋 OPCIÓN RECOMENDADA 2: Tamaño seguro');
    console.log('   Formato: "0.6,0.6,0.5,0.5"');
    console.log('   Descripción: Foto 60% del tamaño, centrada');
    console.log('   Ventajas: Muy seguro, margen amplio');
    console.log('   Uso: Para fotos con márgenes generosos');

    console.log('\n📋 OPCIÓN RECOMENDADA 3: Múltiples fotos');
    console.log('   Formato: "0.4,0.4,0.25,0.25" y "0.4,0.4,0.75,0.25"');
    console.log('   Descripción: Dos fotos de 40% en la parte superior');
    console.log('   Ventajas: Permite múltiples fotos por página');
    console.log('   Uso: Para páginas con varias fotos');

    console.log('\n📋 OPCIÓN RECOMENDADA 4: Coordenadas desde esquina');
    console.log('   Formato: "0.8,0.8,0.1,0.1"');
    console.log('   Descripción: Foto 80% desde esquina superior izquierda');
    console.log('   Ventajas: Posición fija, fácil de calcular');
    console.log('   Uso: Para fotos en posiciones específicas');

    console.log('\n📸 LAYOUTS DE MÚLTIPLES FOTOS RECOMENDADOS:');
    console.log('   Grid 2x2: ".4,.4,0.25,0.25|.4,.4,0.75,0.25|.4,.4,0.25,0.75|.4,.4,0.75,0.75"');
    console.log('   Grid 2x3: ".3,.3,0,.17|.3,.3,.47,.17|.3,.3,.94,.17|.3,.3,.06,.83|.3,.3,.53,.83|.3,.3,1,.83"');
    console.log('   Horizontal 3x1: ".25,.6,0.17,0.5|.25,.6,0.5,0.5|.25,.6,0.83,0.5"');
    console.log('   Vertical 1x3: ".6,.25,0.5,0.17|.6,.25,0.5,0.5|.6,.25,0.5,0.83"');

    console.log('\n⚠️  PROBLEMA CON FORMATO ORIGINAL:');
    console.log('   Formato: "0.8,0.8,0.5,0.25"');
    console.log('   Problema: Y=25% hace que la foto salga por arriba');
    console.log('   Solución: Cambiar Y a 50% o usar validación automática');

    console.log('\n🔧 IMPLEMENTACIÓN ACTUAL:');
    console.log('   - Validación automática: Ajusta formatos que no caben');
    console.log('   - Punto de transformación: Centro de la foto');
    console.log('   - Escala: 0-1 convertida a porcentajes');
    console.log('   - Múltiples fotos: Separadas por |');
    console.log('   - Logging: Muestra ajustes realizados');
  }

  navigateSheet(direction) {
    console.log(`FotobookEditor: Navigating sheet with direction ${direction}`);
    // Avanzar en pares (2 hojas a la vez)
    const newSheet = this.currentPage + (direction * 2);
    console.log(`FotobookEditor: Current sheet: ${this.currentPage}, New sheet: ${newSheet}, Total sheets: ${this.config.totalSheets}`);

    if (newSheet >= 1 && newSheet <= this.config.totalSheets) {
      console.log(`FotobookEditor: Valid navigation, going to sheet ${newSheet}`);
      this.goToPage(newSheet);
    } else {
      console.log(`FotobookEditor: Invalid navigation, staying on sheet ${this.currentPage}`);
    }
  }

  goToPage(page) {
    this.currentPage = page;
    this.updatePageDisplay();

    // Actualizar indicadores de las páginas del libro
    this.updateBookPageIndicators();

    // Actualizar tooltips de las páginas
    this.updatePageTooltips();

    // Cargar formato seleccionado para esta página
    const selectedFormat = this.selectedFormats[page];
    if (selectedFormat) {
      console.log(`FotobookEditor: Loading format for page ${page}:`, selectedFormat);

      // Encontrar y seleccionar el formato correspondiente
      const formatOption = document.querySelector(`.sheet-format-option[data-sheet-id="${selectedFormat.id}"]`);
      if (formatOption) {
        // Seleccionar visualmente el formato
        document.querySelectorAll('.sheet-format-option').forEach(opt => {
          opt.classList.remove('border-petrol-500', 'bg-petrol-50', 'ring-2', 'ring-petrol-500');
          opt.classList.add('border-gray-300');
        });

        formatOption.classList.remove('border-gray-300');
        formatOption.classList.add('border-petrol-500', 'bg-petrol-50', 'ring-2', 'ring-petrol-500');

        // Actualizar vista previa
        this.updateDoublePagePreview(selectedFormat);
      }
    } else {
      console.log(`FotobookEditor: No format found for page ${page}`);

      // Limpiar selección si no hay formato para esta página
      document.querySelectorAll('.sheet-format-option').forEach(opt => {
        opt.classList.remove('border-petrol-500', 'bg-petrol-50', 'ring-2', 'ring-petrol-500');
        opt.classList.add('border-gray-300');
      });

      // Actualizar vista previa con formato vacío para mostrar páginas sin formato
      this.updateDoublePagePreview(null);
    }
  }

  updatePageDisplay() {
    const currentSheetEl = document.getElementById('current-sheet');
    const prevSheetBtn = document.getElementById('prev-sheet');
    const nextSheetBtn = document.getElementById('next-sheet');

    if (currentSheetEl) {
      currentSheetEl.textContent = this.currentPage;
    }

    // Actualizar botones de navegación para pares de hojas
    if (prevSheetBtn) {
      prevSheetBtn.disabled = this.currentPage <= 1;
      if (this.currentPage <= 1) {
        prevSheetBtn.classList.add('opacity-50', 'cursor-not-allowed');
      } else {
        prevSheetBtn.classList.remove('opacity-50', 'cursor-not-allowed');
      }
    }

    if (nextSheetBtn) {
      // El siguiente par debe estar dentro del rango
      const nextPairSheet = this.currentPage + 2;
      nextSheetBtn.disabled = nextPairSheet > this.config.totalSheets;
      if (nextPairSheet > this.config.totalSheets) {
        nextSheetBtn.classList.add('opacity-50', 'cursor-not-allowed');
      } else {
        nextSheetBtn.classList.remove('opacity-50', 'cursor-not-allowed');
      }
    }

    // Actualizar indicador de formato en la hoja actual
    this.updateFormatIndicator();
  }

  updateCoverSheetDisplay() {
    const currentCoverSheetEl = document.getElementById('current-cover-sheet');
    const prevCoverSheetBtn = document.getElementById('prev-cover-sheet');
    const nextCoverSheetBtn = document.getElementById('next-cover-sheet');
    const totalCoverSheetsEl = document.getElementById('total-cover-sheets');

    const currentCoverSheet = this.currentCoverSheet || 1;
    const totalCoverSheets = 1; // Puede ajustarse según la lógica de negocio

    if (currentCoverSheetEl) {
      currentCoverSheetEl.textContent = currentCoverSheet;
    }

    if (totalCoverSheetsEl) {
      totalCoverSheetsEl.textContent = totalCoverSheets;
    }

    // Actualizar botones de navegación de covers
    if (prevCoverSheetBtn) {
      prevCoverSheetBtn.disabled = currentCoverSheet <= 1;
      if (currentCoverSheet <= 1) {
        prevCoverSheetBtn.classList.add('opacity-50', 'cursor-not-allowed');
      } else {
        prevCoverSheetBtn.classList.remove('opacity-50', 'cursor-not-allowed');
      }
    }

    if (nextCoverSheetBtn) {
      nextCoverSheetBtn.disabled = currentCoverSheet >= totalCoverSheets;
      if (currentCoverSheet >= totalCoverSheets) {
        nextCoverSheetBtn.classList.add('opacity-50', 'cursor-not-allowed');
      } else {
        nextCoverSheetBtn.classList.remove('opacity-50', 'cursor-not-allowed');
      }
    }
  }

  updateFormatIndicator() {
    const selectedFormat = this.selectedFormats[this.currentPage];
    const selectedFormatEl = document.getElementById('selected-format');

    if (selectedFormatEl) {
      if (selectedFormat) {
        // Obtener información detallada de la página
        const pageInfo = this.getPageFormatInfo(this.currentPage);

        if (pageInfo) {
          const formatName = `${selectedFormat.noPhotos} foto(s)`;
          const cycleInfo = pageInfo.cycleNumber > 1 ? ` (Ciclo ${pageInfo.cycleNumber})` : '';
          selectedFormatEl.textContent = `${formatName} - Página ${this.currentPage}${cycleInfo}`;
        } else {
          selectedFormatEl.textContent = `${selectedFormat.noPhotos} foto(s) - Página ${this.currentPage}`;
        }

        selectedFormatEl.className = 'text-sm font-medium text-green-600 ml-2';
      } else {
        selectedFormatEl.textContent = 'Sin formato - Selecciona un formato';
        selectedFormatEl.className = 'text-sm font-medium text-orange-600 ml-2';
      }
    }
  }



  debugFormatsState() {
    console.log('\n🔍 DEBUG: ESTADO ACTUAL DE FORMATOS');
    console.log('=====================================');
    console.log(`Página actual: ${this.currentPage}`);
    console.log(`Página seleccionada: ${this.selectedPage}`);
    console.log(`Total de páginas: ${this.config.totalSheets}`);

    console.log('\n📋 FORMATOS ASIGNADOS:');
    for (let page = 1; page <= this.config.totalSheets; page++) {
      const format = this.selectedFormats[page];
      if (format) {
        console.log(`   Página ${page}: ✅ ${format.noPhotos} foto(s) - ID: ${format.id}`);
      } else {
        console.log(`   Página ${page}: ❌ Sin formato`);
      }
    }

    console.log('\n🎯 PÁGINA ACTUAL Y DERECHA:');
    const currentFormat = this.selectedFormats[this.currentPage];
    const rightPage = this.currentPage + 1;
    const rightFormat = this.selectedFormats[rightPage];

    console.log(`   Página actual (${this.currentPage}): ${currentFormat ? `${currentFormat.noPhotos} foto(s)` : 'Sin formato'}`);
    console.log(`   Página derecha (${rightPage}): ${rightFormat ? `${rightFormat.noPhotos} foto(s)` : 'Sin formato'}`);

    console.log('=====================================\n');
  }

  // Método para obtener los datos del fotobook
  getFotobookData() {
    return {
      selectedFormats: this.selectedFormats,
      selectedPhotos: this.selectedPhotos,
      totalPages: this.config.totalSheets
    };
  }

  getPageDimensions() {
    const pageWidth = this.config.pageWidth || 300;
    const pageHeight = this.config.pageHeight || 400;
    return { pageWidth, pageHeight };
  }

  // Obtener las dimensiones reales de página para renderizado de templates
  getRealPageDimensions() {
    const { pageWidth, pageHeight } = this.getPageDimensions();
    return { 
      width: pageWidth, 
      height: pageHeight,
      aspectRatio: pageWidth / pageHeight
    };
  }

  updatePageDimensions() {
    // Obtener las dimensiones reales del paquete
    const { pageWidth, pageHeight } = this.getPageDimensions();
    
    // Actualizar el aspect-ratio de cada página individualmente
    const pageContents = document.querySelectorAll('.page-content');
    pageContents.forEach(pageContent => {
      const aspectRatio = pageWidth / pageHeight;
      pageContent.style.aspectRatio = aspectRatio.toString();
      // Asegurar escalado proporcional
      pageContent.style.maxWidth = '50%';
      pageContent.style.maxHeight = '100%';
      pageContent.style.width = 'auto';
      pageContent.style.height = 'auto';
      console.log(`FotobookEditor: Updated page aspect ratio to ${aspectRatio} (${pageWidth}x${pageHeight})`);
    });

    // Actualizar el viewBox de todos los SVGs de página
    const pageSvgs = document.querySelectorAll('.page-content svg');
    pageSvgs.forEach(svg => {
      svg.setAttribute('viewBox', `0 0 ${pageWidth} ${pageHeight}`);
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      console.log(`FotobookEditor: Updated SVG viewBox to 0 0 ${pageWidth} ${pageHeight}`);
    });

    // Actualizar las dimensiones en la configuración global
    this.config.pageWidth = pageWidth;
    this.config.pageHeight = pageHeight;
    
    console.log(`FotobookEditor: Page dimensions updated to ${pageWidth}x${pageHeight}`);
    
    // Forzar actualización de todos los templates con las nuevas dimensiones
    this.updateAllTemplates();
  }

  // Actualizar todos los templates para usar las nuevas dimensiones
  updateAllTemplates() {
    console.log('FotobookEditor: Updating all templates with new dimensions');
    
    // Actualizar previews de formatos
    this.renderSheetPreviews();
    
    // Actualizar páginas actuales si están renderizadas
    this.updateCurrentPages();
  }

  // Actualizar las hojas actualmente visibles
  updateCurrentPages() {
    const leftSheet = document.getElementById('left-sheet-preview');
    const rightSheet = document.getElementById('right-sheet-preview');
    
    if (leftSheet) {
      const leftContent = leftSheet.querySelector('svg');
      if (leftContent) {
        // Re-renderizar con las nuevas dimensiones
        this.renderCurrentPage();
      }
    }
    
    if (rightSheet) {
      const rightContent = rightSheet.querySelector('svg');
      if (rightContent) {
        // Re-renderizar con las nuevas dimensiones
        this.renderCurrentPage();
      }
    }
  }

  // Renderizar la página actual con el formato seleccionado
  renderCurrentPage() {
    console.log('FotobookEditor: Rendering current page');
    
    // Obtener el formato para la página actual
    const selectedFormat = this.selectedFormats[this.currentPage];
    
    if (selectedFormat) {
      console.log(`FotobookEditor: Rendering page ${this.currentPage} with format:`, selectedFormat);
      
      // Actualizar la vista previa de doble página
      this.updateDoublePagePreview(selectedFormat);
      
      // Actualizar indicadores de las páginas del libro
      this.updateBookPageIndicators();
      
      // Actualizar tooltips de las páginas
      this.updatePageTooltips();
    } else {
      console.log(`FotobookEditor: No format found for page ${this.currentPage}, using default`);
      
      // Renderizar con formato vacío si no hay formato seleccionado
      this.updateDoublePagePreview(null);
    }
  }

  // Diagnóstico de selección de páginas
  diagnosePageSelection() {
    console.log('\n🔍 DIAGNÓSTICO DE SELECCIÓN DE PÁGINAS:');
    console.log('=========================================');
    
    // Verificar elementos HTML
    const leftSheet = document.getElementById('left-sheet-preview');
    const rightSheet = document.getElementById('right-sheet-preview');
    
    console.log(`📄 Hoja izquierda encontrada: ${leftSheet ? '✅ SÍ' : '❌ NO'}`);
    console.log(`📄 Hoja derecha encontrada: ${rightSheet ? '✅ SÍ' : '❌ NO'}`);
    
    if (leftSheet) {
      console.log(`   - ID: ${leftSheet.id}`);
      console.log(`   - Clases: ${leftSheet.className}`);
      console.log(`   - Tiene event listener: ${leftSheet.onclick ? 'SÍ' : 'NO'}`);
    }
    
    if (rightSheet) {
      console.log(`   - ID: ${rightSheet.id}`);
      console.log(`   - Clases: ${rightSheet.className}`);
      console.log(`   - Tiene event listener: ${rightSheet.onclick ? 'SÍ' : 'NO'}`);
    }
    
    // Verificar configuración
    console.log(`\n⚙️ CONFIGURACIÓN:`);
    console.log(`   - Página actual: ${this.currentPage}`);
    console.log(`   - Total de hojas: ${this.config.totalSheets}`);
    console.log(`   - Página derecha calculada: ${this.currentPage + 1}`);
    console.log(`   - ¿Página derecha existe?: ${(this.currentPage + 1) <= this.config.totalSheets ? '✅ SÍ' : '❌ NO'}`);
    
    // Verificar event listeners
    console.log(`\n🎯 EVENT LISTENERS:`);
    console.log(`   - Hoja izquierda (${leftSheet?.id}): ${leftSheet ? '✅ Elemento encontrado' : '❌ No encontrado'}`);
    console.log(`   - Hoja derecha (${rightSheet?.id}): ${rightSheet ? '✅ Elemento encontrado' : '❌ No encontrado'}`);
    
    // Verificar event listeners específicos
    const sheetContents = document.querySelectorAll('.sheet-content');
    console.log(`   - Elementos .sheet-content para drag/drop: ${sheetContents.length}`);
    
    // Verificar formatos asignados
    console.log(`\n📋 FORMATOS ASIGNADOS:`);
    console.log(`   - Página ${this.currentPage}: ${this.selectedFormats[this.currentPage] ? '✅ Formato asignado' : '❌ Sin formato'}`);
    console.log(`   - Página ${this.currentPage + 1}: ${this.selectedFormats[this.currentPage + 1] ? '✅ Formato asignado' : '❌ Sin formato'}`);
    
    console.log('=========================================\n');
  }

  // Método para verificar que las dimensiones se aplicaron correctamente
  verifyDimensions() {
    const { pageWidth, pageHeight } = this.getPageDimensions();
    const pageContents = document.querySelectorAll('.page-content');
    const pageSvgs = document.querySelectorAll('.page-content svg');
    
    console.log('\n🔍 VERIFICACIÓN DE DIMENSIONES:');
    console.log('============================');
    console.log(`📐 Dimensiones del paquete: ${pageWidth}x${pageHeight}`);
    console.log(`📄 Páginas encontradas: ${pageContents.length}`);
    console.log(`🎨 SVGs encontrados: ${pageSvgs.length}`);
    
    pageContents.forEach((pageContent, index) => {
      const aspectRatio = pageContent.style.aspectRatio;
      console.log(`   Página ${index + 1} aspect ratio: ${aspectRatio}`);
    });
    
    pageSvgs.forEach((svg, index) => {
      const viewBox = svg.getAttribute('viewBox');
      console.log(`   SVG ${index + 1} viewBox: ${viewBox}`);
    });
    
    const expectedAspectRatio = (pageWidth / pageHeight).toFixed(3);
    const firstPageAspectRatio = pageContents[0]?.style.aspectRatio;
    
    if (firstPageAspectRatio === expectedAspectRatio) {
      console.log('✅ Aspect ratio aplicado correctamente');
    } else {
      console.log(`❌ Aspect ratio incorrecto. Esperado: ${expectedAspectRatio}, Actual: ${firstPageAspectRatio}`);
    }
    
    return {
      pageWidth,
      pageHeight,
      aspectRatio: firstPageAspectRatio,
      pageCount: pageContents.length,
      svgCount: pageSvgs.length
    };
  }

  // Verificar que los templates se están escalando correctamente
  verifyTemplateScaling() {
    const realDimensions = this.getRealPageDimensions();
    const pageSvgs = document.querySelectorAll('.page-content svg');
    
    console.log('\n🔍 VERIFICACIÓN DE ESCALADO DE TEMPLATES:');
    console.log('==========================================');
    console.log(`📐 Dimensiones reales: ${realDimensions.width}x${realDimensions.height}`);
    console.log(`📄 SVGs de página encontrados: ${pageSvgs.length}`);
    
    pageSvgs.forEach((svg, index) => {
      const viewBox = svg.getAttribute('viewBox');
      const expectedViewBox = `0 0 ${realDimensions.width} ${realDimensions.height}`;
      
      console.log(`   SVG ${index + 1}:`);
      console.log(`     ViewBox actual: ${viewBox}`);
      console.log(`     ViewBox esperado: ${expectedViewBox}`);
      
      if (viewBox === expectedViewBox) {
        console.log(`     ✅ Escalado correcto`);
      } else {
        console.log(`     ❌ Escalado incorrecto`);
      }
    });
    
    // Verificar previews de formatos
    const sheetPreviews = document.querySelectorAll('.sheet-preview svg');
    console.log(`🎨 Previews de formato encontrados: ${sheetPreviews.length}`);
    
    sheetPreviews.forEach((preview, index) => {
      const viewBox = preview.getAttribute('viewBox');
      console.log(`   Preview ${index + 1} viewBox: ${viewBox}`);
    });
    
    return {
      realDimensions,
      pageSvgs: pageSvgs.length,
      sheetPreviews: sheetPreviews.length
    };
  }

  // Verificar que el escalado proporcional funcione correctamente
  verifyProportionalScaling() {
    const pageContents = document.querySelectorAll('.page-content');
    const container = document.getElementById('pages-container');
    
    console.log('\n🔍 VERIFICACIÓN DE ESCALADO PROPORCIONAL:');
    console.log('==========================================');
    console.log(`📦 Contenedor: ${container ? 'Encontrado' : 'No encontrado'}`);
    console.log(`📄 Páginas encontradas: ${pageContents.length}`);
    
    pageContents.forEach((page, index) => {
      const computedStyle = window.getComputedStyle(page);
      const aspectRatio = page.style.aspectRatio;
      const maxWidth = page.style.maxWidth;
      const maxHeight = page.style.maxHeight;
      
      console.log(`   Página ${index + 1}:`);
      console.log(`     Aspect ratio: ${aspectRatio}`);
      console.log(`     Max width: ${maxWidth}`);
      console.log(`     Max height: ${maxHeight}`);
      console.log(`     Display: ${computedStyle.display}`);
      console.log(`     Position: ${computedStyle.position}`);
      
      // Verificar que esté centrada
      const justifyContent = computedStyle.justifyContent;
      const alignItems = computedStyle.alignItems;
      console.log(`     Justify content: ${justifyContent}`);
      console.log(`     Align items: ${alignItems}`);
      
      if (justifyContent === 'center' && alignItems === 'center') {
        console.log(`     ✅ Centrada correctamente`);
      } else {
        console.log(`     ❌ No está centrada`);
      }
    });
    
    return {
      containerFound: !!container,
      pageCount: pageContents.length,
      allCentered: Array.from(pageContents).every(page => {
        const style = window.getComputedStyle(page);
        return style.justifyContent === 'center' && style.alignItems === 'center';
      })
    };
  }

  updatePageSelectionIndicator() {
    // Determinar qué página del libro está seleccionada
    const isLeftPageSelected = this.selectedPage === this.currentPage;
    const isRightPageSelected = this.selectedPage === this.currentPage + 1;

    // Verificar si hay un formato de doble página aplicado
    const leftPageFormat = this.selectedFormats[this.currentPage];
    const rightPageFormat = this.selectedFormats[this.currentPage + 1];
    const isDoublePageFormat = leftPageFormat && rightPageFormat &&
      leftPageFormat.id === rightPageFormat.id &&
      leftPageFormat.double === true;

    if (isDoublePageFormat) {
      console.log(`Páginas ${this.currentPage} y ${this.currentPage + 1} seleccionadas (formato doble página)`);
    } else if (isLeftPageSelected) {
      console.log(`Página ${this.selectedPage} seleccionada (izquierda)`);
    } else if (isRightPageSelected) {
      console.log(`Página ${this.selectedPage} seleccionada (derecha)`);
    }
  }

  updatePageTooltips() {
    // Obtener las hojas del libro
    const leftSheet = document.getElementById('left-sheet-preview');
    const rightSheet = document.getElementById('right-sheet-preview');

    if (!leftSheet || !rightSheet) {
      return;
    }

    // Verificar si hay un formato de doble hoja aplicado
    const leftSheetFormat = this.selectedFormats[this.currentPage];
    const rightSheetFormat = this.selectedFormats[this.currentPage + 1];
    const isDoubleSheetFormat = leftSheetFormat && rightSheetFormat &&
      leftSheetFormat.id === rightSheetFormat.id &&
      leftSheetFormat.double === true;

    // Obtener los tooltips
    const leftTooltip = leftSheet.querySelector('.tooltip-text');
    const rightTooltip = rightSheet.querySelector('.tooltip-text');

    if (isDoubleSheetFormat) {
      // Si hay formato de doble hoja, mostrar advertencia en los tooltips
      if (leftTooltip) {
        leftTooltip.textContent = 'Cambiar formato romperá el doble hoja';
      }
      if (rightTooltip) {
        rightTooltip.textContent = 'Cambiar formato romperá el doble hoja';
      }

      // Cambiar el color del tooltip para indicar advertencia
      const leftTooltipContainer = leftSheet.querySelector('.sheet-tooltip');
      const rightTooltipContainer = rightSheet.querySelector('.sheet-tooltip');

      if (leftTooltipContainer) {
        leftTooltipContainer.className = 'sheet-tooltip absolute bottom-2 left-1/2 transform -translate-x-1/2 bg-orange-600 text-white px-2 py-1 rounded text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 pointer-events-none';
      }
      if (rightTooltipContainer) {
        rightTooltipContainer.className = 'sheet-tooltip absolute bottom-2 left-1/2 transform -translate-x-1/2 bg-orange-600 text-white px-2 py-1 rounded text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 pointer-events-none';
      }
    } else {
      // Si no hay formato de doble hoja, mostrar tooltip normal
      if (leftTooltip) {
        leftTooltip.textContent = 'Seleccionar hoja';
      }
      if (rightTooltip) {
        rightTooltip.textContent = 'Seleccionar hoja';
      }

      // Restaurar el color normal del tooltip
      const leftTooltipContainer = leftSheet.querySelector('.sheet-tooltip');
      const rightTooltipContainer = rightSheet.querySelector('.sheet-tooltip');

      if (leftTooltipContainer) {
        leftTooltipContainer.className = 'sheet-tooltip absolute bottom-2 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white px-2 py-1 rounded text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 pointer-events-none';
      }
      if (rightTooltipContainer) {
        rightTooltipContainer.className = 'sheet-tooltip absolute bottom-2 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white px-2 py-1 rounded text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 pointer-events-none';
      }
    }
  }
} 